import { cn } from '@data/utils/cn/cn';
import { useCallback, type MouseEvent } from 'react';
import { type LinkProps as RLinkProps, Link as RLink } from 'react-router-dom';

export interface LinkProps extends RLinkProps {
  inline?: boolean;
  disabled?: boolean;
}

export function Link({
  className,
  inline,
  disabled,
  onClick,
  ...props
}: LinkProps) {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (disabled) {
        e.preventDefault();
        return;
      }

      onClick?.(e);
    },
    [disabled, onClick]
  );

  return (
    <RLink
      {...props}
      onClick={handleClick}
      aria-disabled={disabled}
      className={cn(
        'rounded-xs text-blue-700 visited:text-purple-700 hover:bg-neutral-100 hover:text-blue-900 hover:underline',
        inline && 'underline',
        disabled &&
          'cursor-not-allowed bg-neutral-100 !text-neutral-700 hover:no-underline',
        className
      )}
    />
  );
}
